import PropTypes from 'prop-types';
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function FileUploadButton({
  label,
  imagesOnly,
  onChange,
  disabled,
  className
}) {
  return _jsxs("label", {
    tabIndex: '0',
    className: `nc-fileUploadButton ${className || ''}`,
    children: [_jsx("span", {
      children: label
    }), _jsx("input", {
      type: "file",
      accept: imagesOnly ? 'image/*' : '*/*',
      onChange: onChange,
      disabled: disabled
    })]
  });
}
FileUploadButton.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  imagesOnly: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};